/* iZENAY Theme — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // Sticky header shadow on scroll
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  // Cart quantity controls
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const line = parseInt(this.dataset.line);
      const action = this.dataset.action;
      const span = this.parentElement.querySelector('span');
      let qty = parseInt(span.textContent);

      if (action === 'increase') qty++;
      else if (action === 'decrease' && qty > 1) qty--;
      else if (action === 'decrease' && qty === 1) {
        if (confirm('Remove this item from your cart?')) {
          window.location.href = `/cart/change?line=${line}&quantity=0`;
          return;
        }
      }

      span.textContent = qty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      })
      .then(r => r.json())
      .then(() => window.location.reload())
      .catch(console.error);
    });
  });

});
